import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';

const UnapprovedIconWrapper = Styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    border-radius: 4px;
    background-color: rgba(208, 2, 27, 0.1);
    margin-right: 8px;
    padding: 0 8px;
`;

const UnapprovedText = Styled.div`
    font-weight: 600;
    font-size: 11px;
    color: #d0021b;
`;

export const UnapprovedIcon = ({text}) => {
	return (
		<UnapprovedIconWrapper>
			<UnapprovedText>{text}</UnapprovedText>
		</UnapprovedIconWrapper>
	);
};

UnapprovedIcon.propTypes = {
	text: PropTypes.string,
};
